(function(){if(window.__novaEffects)return;window.__novaEffects=true;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.nova-reveal:not(.is-watched)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var d = parseInt(e.target.getAttribute('data-delay') || '0', 10);
          setTimeout(function () { e.target.classList.add('is-in'); }, d);
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    els.forEach(function (el) { el.classList.add('is-watched'); io.observe(el); });
  }


function boot(){initReveal(document)};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();document.addEventListener('shopify:section:load',e=>initReveal(e.target));})();
/* ---------- video testimonials ---------- */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.nova-vid__play');
  if (!btn) return;
  var media = btn.closest('[data-nova-video]');
  if (!media) return;
  var src = media.getAttribute('data-nova-video');
  var f = document.createElement('iframe');
  f.src = src;
  f.title = 'Customer video testimonial';
  f.allow = 'accelerometer; autoplay; encrypted-media; picture-in-picture; fullscreen';
  f.setAttribute('allowfullscreen', '');
  media.innerHTML = '';
  media.appendChild(f);
});

